export default {
  dropHint: "画像をドロップ",
  dragDropHint: "画像をドラッグ＆ドロップまたはクリックしてアップロード",
  dropzoneHint: {
    pointer: "画像をドラッグ＆ドロップまたはクリックしてアップロード",
    touch: "タップして写真を選択"
  },
  reuploadHint:
    "元画像のアップロードが完了しました。クリックして再アップロードできます",
  reuploadAction: "再アップロード",
  originalReadyPreview: "元画像をアップロード済み",
  originalPreviewAlt: "アップロード済み元画像のプレビュー",
  originalPreviewFallback: "元画像プレビューを表示できません",
  limitText: "30MB以下",
  compressing: {
    title: "画像を圧縮中",
    message: "画像が大きいため圧縮しています。しばらくお待ちください…",
  },
  loginResume: {
    loadingTitle: "分析中を復元しています",
    loadingMessage: "前回の未完了分析を復元しています。しばらくお待ちください…",
    failedTitle: "前回の分析を復元できませんでした",
    failedMessage: "未完了の記録が見つかりませんでした。写真を再度アップロードしてください。",
    missingImageMessage: "ローカルの画像キャッシュが利用できません。写真を再度アップロードしてください。",
  },
  step: {
    uploadOriginal: "あなたの写真をアップロード",
    selectPreset: "参照スタイルを選択",
  },
  preset: {
    title: "ステップ2：参照スタイルを選択",
    description:
      "今回の編集目標としてプリセットスタイルを1つ選択してください。",
    empty:
      "参照スタイルライブラリは現在利用できません。後でもう一度お試しください。",
    reload: "参照ライブラリを再読み込み",
    imageLoadError: "リソースの読み込みに失敗しました",
    categoryTitle: "スタイルカテゴリ",
    categoryAll: "すべて",
    categoryFeatured: "おすすめ",
    featuredBadge: "おすすめ",
    lightboxAriaLabel: "参照スタイルを拡大表示",
  },
  action: {
    startAnalysis: "分析を開始",
    skipPreset: "参照画像をスキップして互換モードで続行",
  },
  error: {
    invalidType: {
      title: "無効なファイル形式",
      message: "画像ファイルをアップロードしてください",
    },
    tooLarge: {
      title: "ファイルサイズが大きすぎます",
      message: "画像サイズは30MB以下にしてください",
    },
    folderDropped: {
      title: "フォルダは対応していません",
      message: "フォルダではなく、単一の画像ファイルをドラッグしてください。",
    },
    nonFileDropped: {
      title: "対応していないコンテンツ",
      message: "画像ファイルをドラッグしてください。リンクやテキストは受け付けられません。",
    },
    emptyFile: {
      title: "ファイルを取得できませんでした",
      message:
        "読み込み可能な画像ファイルを取得できませんでした。もう一度画像を選択してください。",
    },
    readFailed: {
      title: "画像の読み込みに失敗しました",
      message:
        "画像を読み込めませんでした。本体のギャラリーまたはファイルマネージャーから再度選択するか、別の画像をお試しください。",
    },
    presetRequired: {
      title: "参照スタイルを選択してください",
      message: "分析を開始する前に参照スタイルを1つ選択してください。",
    },
    invalidPreset: {
      title: "参照スタイルが利用できません",
      message:
        "選択された参照スタイルは無効です。別のスタイルを選択してください。",
    },
    relationSaveFailed: {
      title: "分析タスクの初期化に失敗しました",
      message:
        "アップロード関係の保存に失敗しました。しばらくしてからもう一度お試しください。",
    },
  },
};
